import type { AnyFSA } from '@makemydeal/dr-browser-utils';

import { type DashMiddleware, type DashStore, type DashNext, bootstrapSharedActionCreators } from '@makemydeal/dr-shared-store';
import { BuildPayloadPurpose } from '@makemydeal/dr-dash-bff-types';
import { MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

import { SAVE_DEALERSHIP_SELECTION } from '../actionTypes/dealershipSelectionActionTypes';
import { OFFER_SAVE_SUCCESS } from '../actionTypes/offerActionTypes';
import { DEALERSHIP_SELECTION_FLOW } from '../constants';
import { updateDealer } from '../actions/dealerActionsCreators';
import type { Dealership } from '../reducers/dealershipsReducer';
import { saveOfferRSAA } from '../actions/offerActionCreators';
import { getDealValidationState } from '../selectors/dealValidationSelectors';
import { buildOfferSavePayloadObject } from '../utils/offerPayloadUtil';

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);

    switch (action.type) {
        case SAVE_DEALERSHIP_SELECTION: {
            const selectedDealer = action.payload as Dealership;
            store.dispatch(updateDealer({ ...selectedDealer, dealerId: selectedDealer.dealerMMDId }));

            const state = store.getState();
            const offerSavePayload = buildOfferSavePayloadObject(state, BuildPayloadPurpose.OpenDeal);
            const dealValidationNode = getDealValidationState(state);

            store.dispatch(
                saveOfferRSAA({
                    state,
                    offerSavePayload: { ...offerSavePayload, dealValidationNode },
                    source: DEALERSHIP_SELECTION_FLOW
                })
            );
            break;
        }
        case OFFER_SAVE_SUCCESS: {
            if (action.meta?.source === DEALERSHIP_SELECTION_FLOW) {
                store.dispatch(
                    bootstrapSharedActionCreators.fetchBootstrapData(MANAGER_VIEW_APP_PREFIX, { loadDraftScenario: true })
                );
            }
            break;
        }
    }
};
